import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import FloatingButtons from '../../../components/feature/FloatingButtons';

const KasetliTentePage = () => {
  useEffect(() => {
    document.title = 'Kasetli Tente Tamiri - İzmir Tente Tamir | Profesyonel Tamir Hizmeti';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', 'İzmir genelinde profesyonel kasetli tente tamiri hizmeti. Kaset mekanizma arızaları, branda değişimi ve motor tamiri. 0551 372 35 12');
    }
  }, []);

  const otherServices = [
    { title: 'Mafsallı Tente Tamiri', link: '/hizmetler/mafsalli-tente-tamiri' },
    { title: 'Zip Perde Tente', link: '/hizmetler/zip-perde-tente' },
    { title: 'Branda Değişimi', link: '/hizmetler/branda-degisimi' },
    { title: 'Tente Tamiri', link: '/hizmetler/tente-tamiri' }
  ];

  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: 'Inter, sans-serif' }}>
      <Header />
      <FloatingButtons />

      {/* Hero Image Section */}
      <div className="w-full h-64 md:h-96 overflow-hidden">
        <img
          src="https://public.readdy.ai/ai/img_res/7570e128d85e956a4ba7d7eb226e0e6a.jpg"
          alt="Kasetli Tente"
          className="w-full h-full object-cover object-top"
        />
      </div>

      <div className="pt-12 pb-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <nav className="text-sm text-gray-500 mb-6">
            <Link to="/" className="hover:text-gray-900 cursor-pointer">Anasayfa</Link>
            <span className="mx-2">/</span>
            <Link to="/hizmetler" className="hover:text-gray-900 cursor-pointer">Hizmetler</Link>
            <span className="mx-2">/</span>
            <span className="text-gray-900">Kasetli Tente Tamiri</span>
          </nav>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
            <div className="lg:col-span-2">
              <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Poppins, sans-serif' }}>
                Kasetli Tente Tamiri
              </h1>
              
              <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                Kasetli tenteler, modern mimari tasarımın en şık ve fonksiyonel gölgeleme çözümlerinden biridir. Kapalı kaset yapısı sayesinde branda ve mekanizma dış etkenlere karşı korunur. İzmir Tente Tamir olarak, kasetli tente sistemlerinin tüm arızalarına profesyonel ve hızlı çözümler sunuyoruz.
              </p>

              <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8">Kasetli Tente Nedir?</h2>
              <p className="text-gray-700 mb-6 leading-relaxed">
                Kasetli tente, brandanın ve mekanizmanın kapalı bir alüminyum kaset içinde korunduğu tente sistemidir. Tente kapatıldığında branda tamamen kaset içine girer ve dış etkenlere karşı tam koruma sağlanır. Bu özellik sayesinde branda ömrü uzar ve estetik görünüm korunur. Manuel veya motorlu olarak üretilebilir.
              </p>

              <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8">Kasetli Tente Tamiri Kapsamı</h2>
              <p className="text-gray-700 mb-4 leading-relaxed">
                Kasetli tente sistemlerinde karşılaşılan sorunlar ve tamir hizmetlerimiz:
              </p>
              <ul className="space-y-3 mb-6">
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-gray-700"><strong>Kaset Mekanizma Arızaları:</strong> Brandanın kasete giriş-çıkış mekanizmasındaki sorunları gideriyoruz.</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-gray-700"><strong>Branda Değişimi:</strong> Yıpranan veya hasar gören brandaları yenisiyle değiştiriyoruz.</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-gray-700"><strong>Motor ve Kumanda:</strong> Motorlu sistemlerdeki arızaları tespit edip onarıyoruz.</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-gray-700"><strong>Kol Sistemi Tamiri:</strong> Açılma kollarındaki kırılma ve gevşeme sorunlarını çözüyoruz.</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-gray-700"><strong>Kaset Kapak Onarımı:</strong> Kaset kapağındaki hasar ve bozulmaları düzeltiyoruz.</span>
                </li>
              </ul>

              <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8">Tamir Süreci</h2>
              
              <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-6">1. Yerinde İnceleme</h3>
              <p className="text-gray-700 mb-4 leading-relaxed">
                Uzman ekibimiz, kasetli tente sisteminizi yerinde detaylı olarak inceler. Kaset mekanizması, branda durumu, kol sistemi ve motor kontrol edilir. Arızanın kaynağı belirlenerek size rapor edilir.
              </p>

              <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-6">2. Çözüm Önerisi ve Fiyatlandırma</h3>
              <p className="text-gray-700 mb-4 leading-relaxed">
                İnceleme sonrasında, yapılması gereken işlemler ve kullanılacak malzemeler hakkında bilgilendirme yapılır. Şeffaf ve net fiyat teklifi sunulur.
              </p>

              <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-6">3. Profesyonel Tamir</h3>
              <p className="text-gray-700 mb-4 leading-relaxed">
                Onayınızın ardından, orijinal veya eşdeğer kalitede yedek parçalar kullanılarak tamir işlemi gerçekleştirilir. Branda değişiminde kaliteli ve dayanıklı kumaşlar tercih edilir.
              </p>

              <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-6">4. Test ve Kontrol</h3>
              <p className="text-gray-700 mb-6 leading-relaxed">
                Tamir sonrasında sistem kapsamlı testlerden geçirilir. Açılma-kapanma düzgünlüğü, brandanın kasete tam oturması ve genel işlevsellik kontrol edilir. Sorunsuz çalıştığından emin olunduktan sonra size teslim edilir.
              </p>

              <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8">Kasetli Tente Avantajları</h2>
              <ul className="space-y-3 mb-6">
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-gray-700"><strong>Tam Koruma:</strong> Branda kapalıyken kaset içinde korunur, ömrü uzar.</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-gray-700"><strong>Estetik Görünüm:</strong> Modern ve şık tasarımı ile mekanınıza değer katar.</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-gray-700"><strong>Uzun Ömürlü:</strong> Korumalı yapısı sayesinde daha uzun süre kullanılabilir.</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-gray-700"><strong>Kolay Bakım:</strong> Kapalı sistem sayesinde bakım ihtiyacı azalır.</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-gray-700"><strong>Sessiz Çalışma:</strong> Kaset içindeki mekanizma daha sessiz çalışır.</span>
                </li>
              </ul>

              <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8">Bakım Önerileri</h2>
              <p className="text-gray-700 mb-4 leading-relaxed">
                Kasetli tente sisteminizin uzun ömürlü olması için düzenli bakım önemlidir:
              </p>
              <ul className="space-y-3 mb-6">
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-gray-700">Kaset dış yüzeyini düzenli olarak nemli bezle temizleyin</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-gray-700">Brandayı mevsimde bir kez açık halde yumuşak fırça ile temizleyin</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-gray-700">Fırtınalı havalarda tenteyi kapalı tutun</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-gray-700">Yılda bir kez profesyonel bakım hizmeti alın</span>
                </li>
              </ul>

              <div className="bg-gray-50 rounded-xl p-8 mt-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">Hemen Teklif Alın</h2>
                <p className="text-gray-700 mb-6">
                  Kasetli tente tamiriniz için ücretsiz keşif ve fiyat teklifi almak isterseniz bize ulaşın
                </p>
                <div className="flex flex-col sm:flex-row gap-4">
                  <a
                    href="tel:+905513723512"
                    className="px-6 py-3 bg-gray-900 hover:bg-gray-800 text-white text-sm font-semibold rounded-lg transition-colors text-center cursor-pointer whitespace-nowrap"
                  >
                    Telefon: 0551 372 35 12
                  </a>
                  <a
                    href={`https://wa.me/905513723512?text=${encodeURIComponent('Merhaba, izmirtentetamir.net web siteniz üzerinden yazıyorum.')}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="px-6 py-3 border-2 border-gray-900 hover:bg-gray-50 text-gray-900 text-sm font-semibold rounded-lg transition-colors text-center cursor-pointer whitespace-nowrap"
                  >
                    WhatsApp ile Yaz
                  </a>
                </div>
              </div>
            </div>

            <div className="lg:col-span-1">
              <div className="bg-white rounded-xl shadow-lg p-6 sticky top-24">
                <h3 className="text-lg font-bold text-gray-900 mb-4">Diğer Hizmetlerimiz</h3>
                <ul className="space-y-3">
                  {otherServices.map((service, index) => (
                    <li key={index}>
                      <Link
                        to={service.link}
                        className="block p-3 bg-gray-50 hover:bg-gray-100 rounded-lg text-sm font-medium text-gray-900 transition-colors cursor-pointer"
                      >
                        {service.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default KasetliTentePage;
